/* Product refinements: reuse Ira's form, variant resolution and cart submission. */
(() => {
 function setup(scope=document){
  scope.querySelectorAll('[data-sr-sticky-buy]').forEach(bar=>{
   if(bar.dataset.ready)return;bar.dataset.ready='true';
   const product=bar.closest('.shopify-section')||document;
   const form=product.querySelector('form[data-product-form]');if(!form)return;
   const native=form.querySelector('[data-add-to-cart]');if(!native)return;
   const data=JSON.parse(bar.querySelector('[data-sr-sticky-data]').textContent);
   const select=bar.querySelector('[data-sr-sticky-variant]'),buy=bar.querySelector('[data-sr-sticky-submit]');
   const price=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:data.currency||'EUR'});
   function update(v){
    buy.disabled=!v||!v.available||native.disabled;
    buy.textContent=v&&v.available?`${data.buy} · ${price.format(v.price/100)}`:data.soldout;
    if(v){select.value=String(v.id);const image=bar.querySelector('img');const src=v.featured_image?.src;if(image&&src){image.removeAttribute('srcset');image.src=src;}}
   }
   function current(){const id=form.querySelector('[name="id"]')?.value;return data.variants.find(v=>String(v.id)===String(id||select.value));}
   update(current());
   select.addEventListener('change',()=>{
    const v=data.variants.find(v=>String(v.id)===select.value);if(!v)return;
    const pickers=[...form.querySelectorAll('select')].filter(s=>s.name!=='id'&&s.name.startsWith('options['));
    pickers.forEach((picker,i)=>{picker.value=v.options[i];const handle=picker.selectedOptions[0]?.dataset.valueHandle;picker.closest('.pf-container')?.querySelectorAll('[data-button]').forEach(b=>{const active=b.dataset.button===handle;b.classList.toggle('selected',active);b.setAttribute('aria-pressed',String(active));});});
    pickers.forEach(picker=>picker.dispatchEvent(new Event('change',{bubbles:true})));
    update(current());
   });
   form.addEventListener('change',()=>requestAnimationFrame(()=>update(current())));
   new MutationObserver(()=>update(current())).observe(native,{attributes:true,attributeFilter:['disabled']});
   buy.addEventListener('click',()=>{if(!native.disabled)native.click();});
   let passed=false,drawer=false;
   function visibility(){bar.hidden=!passed||drawer;document.body.classList.toggle('sr-buy-visible',!bar.hidden);}
   new IntersectionObserver(entries=>{const e=entries[0];passed=!e.isIntersecting&&e.boundingClientRect.bottom<0;visibility();},{threshold:0}).observe(native);
   document.addEventListener('flu:quick-cart:open',()=>{drawer=true;visibility();});
   document.addEventListener('flu:quick-cart:close',()=>{drawer=false;visibility();});
  });
  scope.querySelectorAll('.product__media-container').forEach(gallery=>{
   if(gallery.dataset.srFit)return;gallery.dataset.srFit='true';
   const content=gallery.closest('.product__content');
   const ambience=document.createElement('div');ambience.className='sr-media-ambience';ambience.setAttribute('aria-hidden','true');content?.prepend(ambience);
   let previous='';
   function fit(){
    const slide=gallery.querySelector('.product__media-item.is-selected')||gallery.querySelector('.product__media-item.initial');
    const img=slide?.querySelector('.media__image img');if(!img||!img.naturalWidth)return;
    // Fit the actual photographic rectangle. No padded frame around a contained image.
    const width=gallery.clientWidth;const h=width*img.naturalHeight/img.naturalWidth;
    gallery.style.setProperty('--sr-media-height',`${h}px`);
    const key=img.currentSrc||img.src;
    const mediaKey=slide.querySelector('[data-media-id]')?.getAttribute('data-media-id')||img.src.split('?')[0];
    if(mediaKey!==previous){const changed=previous!=='';previous=mediaKey;if(ambience&&changed){ambience.style.backgroundImage=`url("${key.replace(/"/g,'%22')}")`;if(!matchMedia('(prefers-reduced-motion: reduce)').matches)ambience.animate([{opacity:0,transform:'translateX(35%)'},{opacity:.45,offset:.3},{opacity:0,transform:'translateX(-20%)'}],{duration:650,fill:'forwards'});}if(changed&&!matchMedia('(prefers-reduced-motion: reduce)').matches)img.animate([{opacity:.4},{opacity:1}],{duration:350});}
   }
   gallery.querySelectorAll('img').forEach(img=>img.addEventListener('load',fit));
   new ResizeObserver(fit).observe(gallery);
   new MutationObserver(fit).observe(gallery.querySelector('.product__media')||gallery,{subtree:true,attributes:true,attributeFilter:['class','src']});fit();
  });
  scope.querySelectorAll('.sr-inline-details .rte').forEach(rte=>{
   rte.querySelectorAll('p').forEach(p=>{if(!p.textContent.replace(/\u00a0/g,'').trim()&&!p.querySelector('img,video,iframe'))p.remove();});
   rte.querySelectorAll('br+br').forEach(br=>br.remove());
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
 document.addEventListener('shopify:section:load',e=>setup(e.target));
})();
